import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  StatusColors,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

interface Props {
  headers: {
    description: string;
    value: string;
    statusValue?: string;
  }[];
  isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHeader',
  props: {
    headers: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  headers: {
    description: string;
    value: string;
    statusValue?: string;
  }[];
  isLoading: boolean;
};



const getValueColor = (color?: string) => {
  if (color) {
    return StatusColors.POSITIVE === color
      ? NebraskaColors.monetaryPositive
      : NebraskaColors.monetaryNegative;
  }

  return NebraskaColors.elementPrimary;
};

return { __sfc: true,props, getValueColor, NebraskaColors, BaseText, SkeletonLoader, Money }
}

})